import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored user on mount
    const storedUser = localStorage.getItem('vip_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { email });
      const userData = response.data;
      setUser(userData);
      localStorage.setItem('vip_user', JSON.stringify(userData));
      return { success: true, user: userData };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('vip_user');
  };

  const logEvent = async (eventType, parcours = null, section = null, metadata = null) => {
    if (!user) return;
    try {
      await axios.post(`${API}/events`, {
        user_id: user.id,
        email: user.email,
        event_type: eventType,
        parcours,
        section,
        metadata
      });
    } catch (error) {
      console.error('Error logging event:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, logEvent }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
